// Phase H.8 — central allowlist for post-auth `redirect_to` query params.
//
// Public-only routes (`/login`, `/signup`) and the auth-flow guards
// (`PublicOnlyRoute`) accept a `?redirect_to=<path>` so that an authenticated
// user lands on the page that initiated the auth (e.g. an invite landing page)
// rather than the role-default dashboard. Anything that gets fed into
// `navigate()` straight from a query param is an open-redirect vector — we
// must hard-allowlist what we accept.
//
// Today the only legitimate `redirect_to` is the invite-claim page. Extend
// this allowlist when (and only when) we add a new pre-auth flow that owns
// the redirect.

const ALLOWED_PATTERNS = [
    /^\/invite\/[A-Za-z0-9_-]+$/,
];

export function isSafeRedirect(path) {
    if (typeof path !== "string") return false;
    if (path.length === 0 || path.length > 256) return false;
    // Hard-block protocol-relative (`//evil.com`) and absolute URLs.
    if (path.startsWith("//")) return false;
    if (!path.startsWith("/")) return false;
    // Block path traversal and embedded query/hash that could shadow the
    // intended path.
    if (path.includes("..")) return false;
    if (path.includes("?") || path.includes("#")) return false;
    // Block any control characters or whitespace.
    // eslint-disable-next-line no-control-regex
    if (/[\u0000-\u001f\s]/.test(path)) return false;
    return ALLOWED_PATTERNS.some((re) => re.test(path));
}

export default isSafeRedirect;
